export default __webpack_public_path__ + "static/media/fd2.a26a153e.jpg";